import React, { Suspense, lazy } from "react";
import { Outlet } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import LoadingSpinner from "common/components/common/LoadingSpinner";
import makeStyles from "@mui/styles/makeStyles";
import NotistackCloseButton from "common/components/button/NotistackCloseButton";
import { Helmet } from "react-helmet";
import { TEST_DOMAIN, DEMO_DOMAIN } from "common/utils/Const";
import { NavigationGuardProvider } from "common/contexts/NavigationGuardContext";

const App =
  process.env.REACT_APP_TARGET === "admin"
    ? lazy(() => import("admin/AdminApp"))
    : lazy(() => import("residents/ResidentsApp"));

const useStyles = makeStyles((theme) => ({
  containerRoot: { top: "65px !important" },
  variantWarning: { color: "#575757 !important" },
}));

export const WrapApp: React.FC = () => {
  const classes = useStyles();
  const domain = window.location.hostname;

  return (
    <SnackbarProvider
      className="no-print"
      maxSnack={5}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      autoHideDuration={5000}
      classes={{
        containerRoot: classes.containerRoot,
      }}
      action={(key) => <NotistackCloseButton snackbarKey={key} />}
    >
      <NavigationGuardProvider>
        {/* HelmetでmetaタグやGoogle Analyticsを設定 */}

        <meta
          name="keywords"
          content="けんしん,健康診断,健康診査,健診,検診,予約,クラウド,サービス,健診予約システム,特定健診,がん検診,人間ドック,生活習慣病,健康管理,医療機関"
        />
        <meta
          name="description"
          content="けんしん予約システムは、健康診断・健康診査の予約を簡単に管理できるクラウドサービスです。"
        />
        {/* テスト用 Google Analytics */}
        {domain === TEST_DOMAIN ? (
          <Helmet>
            <script
              async
              src="https://www.googletagmanager.com/gtag/js?id=G-QR0GQCVK17"
            ></script>
            <script>
              {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-QR0GQCVK17');
      `}
            </script>
          </Helmet>
        ) : domain === DEMO_DOMAIN ? (
          // デモ用 Google Analytics
          <></>
        ) : (
          // 本番用 Google Analytics
          <></>
        )}

        <div className="app-container">
          <main className="app-content">
            <Suspense fallback={<LoadingSpinner />}>
              <Outlet />
              <App />
            </Suspense>
          </main>
        </div>
      </NavigationGuardProvider>
    </SnackbarProvider>
  );
};
